export default __webpack_public_path__ + "static/media/VideoPlayButton.c9d42f8b.svg";